import React, { createContext, useContext, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isAdmin, setIsAdmin] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // 1. Verificar sesión activa al cargar la app
        supabase.auth.getSession().then(({ data: { session } }) => {
            handleUserChange(session?.user ?? null);
        });

        // 2. Escuchar cambios (Login/Logout)
        const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
            handleUserChange(session?.user ?? null);
        });

        return () => subscription.unsubscribe();
    }, []);

    const handleUserChange = async (currentUser) => {
        if (currentUser) {
            
            // Verificamos si es admin en la base de datos
            const { data, error } = await supabase
                .from('admin')
                .select('role')
                .ilike('email', currentUser.email)
                .maybeSingle();

            // Si NO está autorizado (Error o no existe en la tabla)
            if (error || !data) {
                console.warn("Intento de acceso no autorizado:", currentUser.email);
                await supabase.auth.signOut();
                setUser(null);
                setIsAdmin(false);
                alert("⛔ Acceso denegado: Tu email no está autorizado.");
                window.location.replace("/"); 
                return;
            } else {
                // ✅ USUARIO AUTORIZADO
                setUser(currentUser);
                setIsAdmin(data?.role === 'admin');

                // 🔥 AGREGADO: REDIRECCIÓN DE ÉXITO
                // Si el login fue exitoso y seguimos en la ruta "entrada...",
                // forzamos la ida al inicio para limpiar la URL.
                if (window.location.pathname.includes("entrada")) {
                    window.location.replace("/");
                }
            }
            
        } else {
            // No hay usuario (sesión cerrada o no iniciada)
            setUser(null);
            setIsAdmin(false);
        }
        setLoading(false);
    };

    const logout = async () => {
        await supabase.auth.signOut();
        window.location.href = "/"; 
    };

    return (
        <AuthContext.Provider value={{ user, isAdmin, logout, loading }}>
            {!loading && children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);